import React, { useState } from 'react';
import CheckIcon from '../icons/CheckIcon';
import CloseIcon from '../icons/CloseIcon';
import { mergeClasses } from '../utils/styles.util';

interface InlineTextFormProps {
  initialValue?: string;
  placeholder?: string;
  onConfirm: (value: string) => void | Promise<void>;
  onCancel: () => void;
  className?: string;
  inputClassName?: string;
  closeIconClassName?: string;
}

const InlineTextForm: React.FC<InlineTextFormProps> = ({
  initialValue = '',
  placeholder,
  onConfirm,
  onCancel,
  className,
  inputClassName,
  closeIconClassName,
}) => {
  const [value, setValue] = useState(initialValue);

  const confirm = async () => {
    const trimmed = value.trim();
    if (trimmed === '') { onCancel(); return; }
    await onConfirm(trimmed);
  };

  return (
    <div className={mergeClasses("flex items-center gap-2", className)}>
      <input
        type="text"
        autoFocus
        className={mergeClasses("border rounded px-2 py-1 text-sm", inputClassName)}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') confirm(); if (e.key === 'Escape') onCancel(); }}
      />
      <div className="cursor-pointer" onClick={confirm}><CheckIcon /></div>
      <div className="cursor-pointer" onClick={onCancel}><CloseIcon className={closeIconClassName} /></div>
    </div>
  );
};

export default InlineTextForm;
